import getMessage from 'src/background/utils/i18n.utils';
import React, { useState } from 'react';
import ButtonComponent, { ButtonType, } from 'src/common-ui/button/button.component';
import { InputType } from 'src/common-ui/input/input-type.enum';
import InputComponent from 'src/common-ui/input/input.component';
export const MetadataPopup = ({ initialMetadata, onSubmit, onCancel, }) => {
    const [metadataForm, setMetadataForm] = useState(initialMetadata);
    const updateMetadataForm = (section, key, value) => {
        setMetadataForm((old) => {
            const newState = Object.assign({}, old);
            if (newState && newState[section]) {
                newState[section][key] = value;
            }
            return newState;
        });
    };
    return (React.createElement("div", { className: "metadata-popup" },
        React.createElement("div", { className: "metadata-content" }, metadataForm.twoFACodes !== undefined && (React.createElement("div", { className: "two-fa-codes" },
            React.createElement("div", { className: "section-title" }, getMessage('multisig_bot_two_fa_codes')),
            Object.keys(metadataForm.twoFACodes).map((botName) => (React.createElement(InputComponent, { type: InputType.TEXT, key: `bot-${botName}`, label: getMessage('multisig_bot_two_fa_code', [
                    botName,
                ]), skipLabelTranslation: true, value: metadataForm.twoFACodes[botName], onChange: (newValue) => {
                    updateMetadataForm('twoFACodes', botName, newValue);
                } })))))),
        React.createElement("div", { className: "metadata-footer" },
            React.createElement(ButtonComponent, { label: "popup_html_button_label_cancel", onClick: () => onCancel(), type: ButtonType.ALTERNATIVE, height: "small" }),
            React.createElement(ButtonComponent, { label: "popup_html_submit", onClick: () => onSubmit(metadataForm), height: "small" }))));
};
